import OemAdmin from 'components/OemAdmin';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import AllianceLogo from "images/Alliance-Logo-500.png";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { logout } from 'services/auth.service';
import { clear } from '../../reducers/alert.slice';
import { resetUser } from '../../reducers/auth.slice';
import { clearCases } from '../../reducers/case.slice';
import { clearCreditMemos } from '../../reducers/credit.slice';
import { clearCustomer } from '../../reducers/customer.slice';
import { clearDto } from '../../reducers/dto.slice';
import { clearInvoices } from '../../reducers/invoice.slice';
import { clearOrder, clearOrders } from '../../reducers/order.slice';
import { clearPdf } from '../../reducers/pdf.slice';
import { clearReturns } from '../../reducers/return.slice';

const Header = () => {
    const [toggleState, setToggleState] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(x => x.authentication.user);
    const customers = useAppSelector(x => x.customers.oemDropDown);

    const onLogoutClick = async () => {
        
        await dispatch(logout());
        dispatch(resetUser());
        localStorage.removeItem('user');
        dispatch(clearCustomer());
        dispatch(clearDto());
        dispatch(clear());
        dispatch(clearCases());
        dispatch(clearCreditMemos());
        dispatch(clearInvoices());
        dispatch(clearOrder());
        dispatch(clearOrders());
        dispatch(clearReturns());
        dispatch(clearPdf());
    };

    const toggle = () => {
        setToggleState(!toggleState);
    };

    return (
        <Navbar color="light" light expand="md" id="bcd-main-header" className="sticky-top">
            <NavbarBrand href="https://central.bcdvideo.com/">
                {currentUser ?
                    <>
                        <img className="bcd-app-icon" src="https://central.bcdvideo.com/images/CentralIcon.png" alt="BCD Central" />
                        ENTRAL
                    </>
                    :
                    <img className="bcd-app-icon" src="https://central.bcdvideo.com/images/BCD-Logo.png" alt="BCD" />
                }
            </NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={toggleState} navbar>
                <Nav navbar>
                    <NavItem>
                        <Link to="/" className="nav-link">
                            <sub>
                                <img src={AllianceLogo} alt="BCD Alliance" className="bcd-alliance-icon" />
                            </sub>
                        </Link>
                    </NavItem>
                    {(currentUser?.roles.includes('Administrator') || customers.length > 1) && <OemAdmin />}
                </Nav>
                <Nav className="ms-auto" navbar>
                    {currentUser ?
                        <>
                            <NavItem className="text-end">
                                <NavLink href="#">{currentUser.email}</NavLink>
                            </NavItem>
                            <NavItem className="text-end">
                                <NavLink href="#" onClick={onLogoutClick}>Logout</NavLink>
                            </NavItem>
                        </>
                        :
                        <>
                            <NavItem className="text-end">
                                <Link to="/alliance/login" className="nav-link" reloadDocument>
                                    Login
                                </Link>
                            </NavItem>
                            <NavItem className="text-end">
                                <NavLink href="https://central.bcdvideo.com/Account/Register">Register</NavLink>
                            </NavItem>
                        </>
                    }
                </Nav>
            </Collapse>
        </Navbar>
    );
}

export default Header;